__turbopack_context__.v({
  "className": "ibm_plex_sans_614112cf-module__yj3bEa__className",
  "variable": "ibm_plex_sans_614112cf-module__yj3bEa__variable",
});
